import React from 'react'
import { change, show, store, update, success as changeSuccess } from '../../../store/actions/google.action'
import { CircularProgress, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core'
import { FaSave } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen } from '../../../store/actions/navigation.action'

export default function GoogleEdit(props) {
    const dispatch = useDispatch()
    const { tag, success, error } = useSelector(state => state.googleReducer)
    const id = (props.uid) ? props.uid : null

    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        if (id) {
            dispatch(show(id)).then(res => res && setLoading(false))
        } else {
            setLoading(false)
        }
        return () => {
            dispatch(change('clear'))
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        if(id) {
            dispatch(update(id, tag))
        } else {
            dispatch(store({
                'title' : tag.title,
                'container' : tag.container,
                'share_data' : tag.share_data
            }))
        }
    }

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Tag Manager' : 'Novo Tag Manager'}
                    </Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => _save() }
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Titulo</label>
                            <TextField
                                error={(error.title) && true}
                                value={tag.title || ''}
                                placeholder="Ex: Google Tag Manager Instagram"
                                onChange={text => {
                                    dispatch(change({ title: text.target.value }))
                                    if (error.title && delete error.title);
                                }}
                            />

                            {(error.title) &&
                                <strong className="text-danger">{error.title[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Container</label>
                            <TextField
                                error={(error.container) && true}
                                value={tag.container || ''}
                                placeholder="EX: GTM-K3HC7QSM"
                                onChange={text => {
                                    dispatch(change({ container: text.target.value }))
                                    if (error.container && delete error.container);
                                }}
                            />

                            {(error.container) &&
                                <strong className="text-danger">{error.container[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Envio de Dados</FormLabel>
                                <RadioGroup
                                    value={tag.share_data || 'all'} 
                                    onChange={ e => dispatch(change({share_data: e.target.value}))}
                                    className="fw-bold bs-color-b"
                                >
                                    <FormControlLabel value="all" control={<Radio color="primary" />} label="Total" />
                                    <FormControlLabel value="only" control={<Radio color="primary" />} label="Parcial" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        <div className="mb-3">
                            <div className="alert alert-success mt-3" role="alert">
                                <strong>Total:</strong> O Google Tag Manager coleta dados de todas as páginas.
                            </div>
                            <div className="alert alert-warning mt-3" role="alert">
                                <strong>Parcial:</strong> O Google Tag Manager coleta dados apenas de links que estejam utilizando esta tag.
                            </div>
                        </div> 
                    </div>
                </>
            }
        </div>
    )
}